import IdentifyAssetView from "./IdentifyAssetView";
export default IdentifyAssetView;
